var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1320_696)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 30,
    height: 30,
    fill: "url(#pattern0)",
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1320_696",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1320_696"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1320_696",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1320_696",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1320_696",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.99d34ef1a7ce37b3c5c030f3bc3eea13.svg";
export { ForwardRef as ReactComponent };